function setHalfSpacing() {
  const root = document.documentElement;
  // const wrapperWidth = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wrapper-mw'));
  const wrapperWidth = '1200';
  if (!wrapperWidth) return;

  const usableWidth = document.documentElement.clientWidth;
  const result = Math.max((usableWidth - wrapperWidth) / 2, 0);

  root.style.setProperty('--half-spacing', result + 'px');
}

setHalfSpacing();

window.addEventListener('resize', setHalfSpacing);

document.addEventListener('shopify:section:load', setHalfSpacing);
document.addEventListener('shopify:section:reorder', setHalfSpacing);
document.addEventListener('shopify:section:unload', setHalfSpacing);

document.addEventListener('DOMContentLoaded', () => {
  const navigation = document.querySelector('.t4s-navigation');

  if (!navigation) return;

  navigation.addEventListener(
    'mouseenter',
    function (e) {
      const tabTitle = e.target.closest('.mega-tab-title');
      if (!tabTitle) return;

      const tab = tabTitle.closest('.type_tab_pr');
      if (!tab) return;

      const tabTitles = tab.querySelectorAll('.mega-tab-title');
      const tabContents = tab.querySelectorAll('.mega-tab-content');
      const contentsWrapper = tab.querySelector('.mega-tab-contents');

      if (!contentsWrapper) return;

      const index = Array.from(tabTitles).indexOf(tabTitle);

      if (index === -1 || !tabContents[index]) return;

      const activeContent = tab.querySelector('.mega-tab-content.active');
      const targetContent = tabContents[index];

      if (activeContent === targetContent) return;

      /**
       * 获取 wrapper 上下 padding
       */
      const getWrapperPadding = () => {
        const style = getComputedStyle(contentsWrapper);

        const paddingTop = parseFloat(style.paddingTop) || 0;
        const paddingBottom = parseFloat(style.paddingBottom) || 0;

        return paddingTop + paddingBottom;
      };

      /**
       * 获取 content 内第一个非 link 的直接子元素高度
       * 再加上 wrapper 的上下 padding
       */
      const getContentHeight = (content) => {
        if (!content) return 0;

        const firstContent = content.querySelector(
          ':scope > :not(link)'
        );

        if (!firstContent) return 0;

        return firstContent.offsetHeight + getWrapperPadding();
      };

      // 清除上一次 timer
      clearTimeout(contentsWrapper.__heightTimer);

      /**
       * 当前高度
       *
       * 正常情况下取当前 active content 的第一个有效元素高度。
       * 如果当前正在动画，则直接取 wrapper 当前视觉高度，
       * 避免快速切换时发生跳动。
       */
      let startHeight;

      if (contentsWrapper.style.height) {
        startHeight = contentsWrapper.getBoundingClientRect().height;
      } else {
        startHeight = getContentHeight(activeContent);
      }

      // 锁定当前高度
      contentsWrapper.style.height = `${startHeight}px`;

      // 切换 title
      tabTitles.forEach((title, i) => {
        title.classList.toggle('active', i === index);
      });

      // 切换 content
      if (activeContent) {
        activeContent.classList.remove('active');
      }

      targetContent.classList.add('active');

      // 获取目标高度
      const targetHeight = getContentHeight(targetContent);

      /**
       * 高度一致
       * 不会触发 transitionend，所以直接清除 height
       */
      if (Math.abs(startHeight - targetHeight) < 1) {
        contentsWrapper.style.removeProperty('height');
        return;
      }

      // 强制浏览器确认 startHeight
      void contentsWrapper.offsetHeight;

      const cleanup = () => {
        contentsWrapper.style.removeProperty('height');

        contentsWrapper.removeEventListener(
          'transitionend',
          onTransitionEnd
        );

        clearTimeout(contentsWrapper.__heightTimer);

        contentsWrapper.__heightTimer = null;
      };

      const onTransitionEnd = (event) => {
        if (event.target !== contentsWrapper) return;
        if (event.propertyName !== 'height') return;

        cleanup();
      };

      contentsWrapper.addEventListener(
        'transitionend',
        onTransitionEnd
      );

      requestAnimationFrame(() => {
        contentsWrapper.style.height = `${targetHeight}px`;
      });

      // 防止 transitionend 没触发
      contentsWrapper.__heightTimer = setTimeout(() => {
        cleanup();
      }, 500);
    },
    true
  );
});

// 轮播图内视频自动播放

(function () {
  'use strict';
  if (window.t4sSlideshowVideoAutoplay) return;

  var selector = '.t4s-slideshow-inner video';
  var videos = new Map();
  var frame = 0;

  function isSelected(video) {
    var slide = video.closest('.t4s-slideshow-item');
    return !!slide && slide.classList.contains('is-selected');
  }

  function syncVideo(video, state) {
    if (!video.isConnected || !isSelected(video)) {
      video.pause();
      return;
    }
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    if (!video.paused || state.pending) return;
    state.pending = true;
    try {
      Promise.resolve(video.play()).catch(function () {
        // Retry on a later selection, media readiness event, or user gesture.
      }).finally(function () {
        state.pending = false;
        if (!video.isConnected || !isSelected(video)) video.pause();
      });
    } catch (error) {
      state.pending = false;
    }
  }

  function syncAll() {
    frame = 0;
    videos.forEach(function (state, video) {
      if (!video.isConnected || !video.matches(selector)) {
        state.events.forEach(function (event) {
          video.removeEventListener(event, state.sync);
        });
        video.pause();
        videos.delete(video);
      }
    });
    document.querySelectorAll(selector).forEach(function (video) {
      if (videos.has(video)) return;
      var state = { pending: false, events: ['loadeddata', 'canplay', 'play'] };
      state.sync = function () { syncVideo(video, state); };
      videos.set(video, state);
      state.events.forEach(function (event) {
        video.addEventListener(event, state.sync);
      });
    });
    videos.forEach(function (state, video) { syncVideo(video, state); });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(syncAll);
  }

  var observer = new MutationObserver(function (records) {
    if (records.some(function (record) {
      return record.type === 'childList' ||
        (record.target.matches('.t4s-slideshow-item') &&
          /(?:^|\s)is-selected(?:\s|$)/.test(record.oldValue || '') !==
          record.target.classList.contains('is-selected'));
    })) schedule();
  });

  function start() {
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
    document.addEventListener('pointerdown', schedule, { passive: true });
    document.addEventListener('keydown', schedule);
    syncAll();
  }

  window.t4sSlideshowVideoAutoplay = { refresh: schedule };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/**
 * 通用复制函数（Clipboard API + execCommand）
 */
async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error('Clipboard API 复制失败', err);
      return false;
    }
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      return success;
    } catch (err) {
      console.error('execCommand 复制失败', err);
      document.body.removeChild(textarea);
      return false;
    }
  }
}

// 绑定事件：点击复制 data-code
document.querySelectorAll('.discount').forEach(el => {
  const code = el.querySelector('.discount-code');
  const data = code.dataset.code;
  const btn = el.querySelector('.discount-btn');
  const text = btn.innerHTML;

  btn.addEventListener('click', async () => {
    const result = await copyText(data);
    if (result) {
      // ✅ 复制成功提示，可以换成 toast
      el.classList.add('active');
      btn.textContent = 'Copied!';
      setTimeout(() => {
        el.classList.remove('active');
        btn.textContent = text; // 恢复原文字
      }, 1500);
    } else {
      alert('复制失败');
    }
  });
});

function getProductNavOffset(el) {
  const styles = getComputedStyle(document.documentElement);

  const topbarHeight = parseFloat(styles.getPropertyValue('--topbar-height')) || 0;

  const headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;

  const navHeight = el?.querySelector('.nav-list')?.offsetHeight || 0;

  return (topbarHeight + headerHeight + navHeight + 40);
}

function initProductNav(el) {
  if (el.__initProductNav) return;
  el.__initProductNav = true;

  const nav = el.querySelector('.nav-list');
  const navItems = el.querySelectorAll('.nav-list-item');
  const sections = el.querySelectorAll(
    '.product-information-block > div[id]'
  );

  if (!nav || !navItems.length || !sections.length) return;

  let currentActiveId = null;
  let ticking = false;

  function updateActive() {
    const offset = getProductNavOffset(el);

    // 给浏览器小数像素 / 滚动取整留一点容差
    const threshold = offset + 2;

    let activeId = sections[0].id;

    for (const section of sections) {
      const rect = section.getBoundingClientRect();

      if (rect.top <= threshold) {
        activeId = section.id;
      } else {
        break;
      }
    }

    if (activeId === currentActiveId) return;

    currentActiveId = activeId;

    navItems.forEach(item => {
      item.classList.toggle(
        'active',
        item.dataset.target === activeId
      );
    });
  }

  function handleScroll() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      updateActive();
      ticking = false;
    });
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  window.addEventListener('resize', handleScroll);

  updateActive();
}

function changeHash(idName) {
  const target = document.querySelector(idName);

  if (!target) return;

  const productInformation = target.closest('.product-information');

  const offset = getProductNavOffset(productInformation);

  const targetTop =
    target.getBoundingClientRect().top +
    window.scrollY -
    offset;

  window.scrollTo({
    top: targetTop,
    behavior: 'smooth'
  });
}

function initScroll(el) {
  if (el.__initScroll) return;
  el.__initScroll = true;

  const wrapper = el.querySelector('.custom-scroll-wrapper');
  const items = el.querySelectorAll('.custom-scroll-item');
  const prevButton = el.querySelector('.custom-scroll-prev');
  const nextButton = el.querySelector('.custom-scroll-next');

  if (!wrapper || !items.length) return;

  const perPage = Number(el.dataset.perPage) || 4;
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const canMouseDrag = el.hasAttribute('data-drag') || isMobile;

  let currentPage = 0;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function getMaxScrollLeft() {
    return Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
  }

  function getMaxPage() {
    return Math.max(0, Math.ceil(items.length / perPage) - 1);
  }

  function getItemLeft(item) {
    return item.getBoundingClientRect().left - wrapper.getBoundingClientRect().left + wrapper.scrollLeft;
  }

  function getScrollLeft(page) {
    const maxPage = getMaxPage();

    if (page >= maxPage) {
      return getMaxScrollLeft();
    }

    const targetItem = items[page * perPage];

    if (!targetItem) {
      return getMaxScrollLeft();
    }

    return clamp(getItemLeft(targetItem), 0, getMaxScrollLeft());
  }

  function getClosestPage() {
    const maxPage = getMaxPage();
    const maxScrollLeft = getMaxScrollLeft();

    if (wrapper.scrollLeft >= maxScrollLeft - 1) {
      return maxPage;
    }

    let closestPage = 0;
    let closestDistance = Infinity;

    for (let page = 0; page <= maxPage; page++) {
      const distance = Math.abs(wrapper.scrollLeft - getScrollLeft(page));

      if (distance < closestDistance) {
        closestDistance = distance;
        closestPage = page;
      }
    }

    return closestPage;
  }

  function updateButtons() {
    const maxPage = getMaxPage();

    if (prevButton) {
      prevButton.disabled = currentPage <= 0;
    }

    if (nextButton) {
      nextButton.disabled = currentPage >= maxPage;
    }
  }

  function goToPage(page) {
    const maxPage = getMaxPage();

    currentPage = clamp(page, 0, maxPage);

    wrapper.scrollTo({
      left: getScrollLeft(currentPage),
      behavior: 'smooth'
    });

    updateButtons();
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      goToPage(currentPage - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      goToPage(currentPage + 1);
    });
  }

  if (canMouseDrag) {
    let pointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let pointerId = null;

    const dragThreshold = 5;

    function resetDrag() {
      pointerDown = false;
      isDragging = false;
      wrapper.classList.remove('is-dragging');

      currentPage = getClosestPage();
      updateButtons();

      if (
        pointerId !== null &&
        wrapper.hasPointerCapture(pointerId)
      ) {
        wrapper.releasePointerCapture(pointerId);
      }

      pointerId = null;
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;

      pointerDown = true;
      startX = e.clientX;
      startScrollLeft = wrapper.scrollLeft;
      pointerId = e.pointerId;
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;

      const moveX = e.clientX - startX;

      // 移动超过阈值后，才认为是在拖动
      if (!isDragging && Math.abs(moveX) > dragThreshold) {
        isDragging = true;
        wrapper.classList.add('is-dragging');
        wrapper.setPointerCapture(e.pointerId);
      }

      if (!isDragging) return;

      // 防止拖动过程中触发浏览器默认行为
      e.preventDefault();

      wrapper.scrollLeft = clamp(
        startScrollLeft - moveX,
        0,
        getMaxScrollLeft()
      );
    });

    wrapper.addEventListener('pointerup', resetDrag);
    wrapper.addEventListener('pointercancel', resetDrag);
    wrapper.addEventListener('lostpointercapture', resetDrag);

    wrapper.addEventListener('dragstart', function (e) {
      if (pointerDown) {
        e.preventDefault();
      }
    });
  }

  wrapper.addEventListener('scroll', function () {
    currentPage = getClosestPage();
    updateButtons();
  });

  updateButtons();
}

const watchList = [
  {
    selector: '.product-information',
    handler: initProductNav,
    flag: '__initProductNav'
  },
  {
    selector: '.custom-scroll',
    handler: initScroll,
    flag: '__initScroll'
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});